import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M3.746 10c0-.795.148-1.556.419-2.255A.995.995 0 0 0 4.7 7.9h.922a4.854 4.854 0 0 0 6.478 6.478v.922c0 .197.057.38.155.535A6.254 6.254 0 0 1 3.745 10Zm12.09 2.255a6.254 6.254 0 0 0-8.09-8.09.995.995 0 0 1 .154.535v.922a4.854 4.854 0 0 1 6.478 6.478h.922c.197 0 .38.057.535.155Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M3 3.7a.7.7 0 0 1 .7-.7h4.2a.7.7 0 0 1 .7.7v4.2a.7.7 0 0 1-.7.7H3.7a.7.7 0 0 1-.7-.7V3.7Zm1.4.7v2.8h2.8V4.4H4.4ZM11.4 12.1a.7.7 0 0 1 .7-.7h4.2a.7.7 0 0 1 .7.7v4.2a.7.7 0 0 1-.7.7h-4.2a.7.7 0 0 1-.7-.7v-4.2Zm1.4.7v2.8h2.8v-2.8h-2.8Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
